import type { SVGProps } from "react";
const Dot = (props: SVGProps<SVGSVGElement>) => <svg width={16} height={16} fill="none" viewBox="0 0 16 16" aria-hidden="true" focusable="false" className="choiceform-icon" {...props}><path fill="currentColor" d="M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6" /></svg>;
export default Dot;